<div class="container-fluid p-0">
  <div class="tab-description">
    Add and manage languages to show questions and labels in the user’s preferred language.
  </div>
  <!-- Action Bar -->
  <div class="d-flex justify-content-between align-items-center mb-4">
    <!-- Add New Language Button -->
    <button class="add-language-btn"
      [disabled]="!hasAvailableLanguages || !isUserHasWriteAccess"
      [title]="hasAvailableLanguages ? 'Add a new language to your conversation' : 'All available languages have been added'"
      (click)="openAddLanguageModal()">
      Add New Language
    </button>

    <!-- Search & Save Group -->
    <div class="search-language-group d-flex align-items-center" style="gap: 12px;">
      <div class="search-language-box position-relative">
        <span class="search-language-icon"><img src="./assets/images/search-icon.svg"></span>
        <input type="text" class="search-language-input" placeholder="Search language" [(ngModel)]="searchText"
          [disabled]="!languages || languages.length === 0">
      </div>
      <button class="save-language-btn"
        [disabled]="!isLanguageOrderDirty || !isUserHasWriteAccess"
        [ngClass]="{'active': isLanguageOrderDirty}"
        (click)="saveLanguageOrder()">
       <span class="save-btn-new">Save</span> 
      </button>
    </div>
  </div>

  <!-- Loading State -->
  <div class="text-center py-5" *ngIf="loading">
    <div class="spinner-border text-primary" role="status">
      <span class="visually-hidden">Loading...</span>
    </div>
    <p class="mt-2">Loading languages...</p>
  </div>

  <!-- Empty State -->
  <div class="empty-state" *ngIf="!loading && !( languages && languages.length)">
    <div class="text-center py-5">
      <i class="fa fa-language fa-3x text-muted mb-3"></i>
      <h5>No Languages Available</h5>
      <p class="text-muted">Click on "Add New Language" to add your first language</p>
    </div>
  </div>

  <!-- Languages List -->
  <div class="languages-container" *ngIf="!loading && languages && languages.length > 0" cdkDropList
    [cdkDropListData]="filteredLanguages" (cdkDropListDropped)="onDrop($event)" [cdkDropListDisabled]="!isUserHasWriteAccess">

    <div class="language-card" *ngFor="let lang of filteredLanguages" cdkDrag [cdkDragData]="lang">
      <!-- Drag Handle -->
      <div class="drag-handle" cdkDragHandle title="Click and drag up or down to rearrange languages">
     <svg class="icon-set">
          <use [attr.xlink:href]="'./assets/images/icons.svg#reorder'"></use>
        </svg>
      </div>

      <!-- Language Icon -->
      <!-- <div class="language-icon">
        <i class="fa fa-language"></i>
      </div> -->

      <!-- Language Content -->
      <div class="language-content">
        <div class="language-info">
          <span class="language-name" style="text-transform: capitalize;">{{ lang.name || lang.language }}</span>
          <span class="default-badge" *ngIf="defaultLanguage === lang.key">Default</span>
        </div>
      </div>

      <!-- Actions -->
      <div class="language-actions">
        <button *ngIf="defaultLanguage !== lang.key" [disabled]="!isUserHasWriteAccess" class="btn btn-outline-primary btn-sm default-button"
          (click)="setDefaultLanguage(lang.key)" title="Set this language as default conversation feedback language">
          Set as Default
        </button>

        <button class="btn action-btn"  (click)="editLanguage(lang)" title="Edit language translations">
          <img  src="./assets/images/editIcon.svg">
        </button>

        <button class="btn action-btn"  (click)="removeLanguage(lang.key)" [disabled]="defaultLanguage === lang.key || !isUserHasWriteAccess"
          title="Delete this language">
          <svg class="icon-set">
            <use [attr.xlink:href]="'./assets/images/icons.svg#trash-can-outline'"></use>
          </svg>
        </button>
      </div>
    </div>
  </div>
</div>

<!-- Add Language Side Panel -->
<div class="add-language-side-panel" *ngIf="showAddLanguageModal">
  <div class="side-panel-overlay" (click)="closeAddLanguageModal()"></div>
  <div class="side-panel-container">
    <div class="side-panel-header">
      <div class="header-label">Language</div>
      <button class="close-button" (click)="closeAddLanguageModal()">
        <!-- <i class="fa fa-times"></i> -->
        <img src="./assets/images/close.svg">
      </button>
    </div>

    <div class="side-panel-content">
      <div class="language-selection-form">
        <span>Choose a language</span>
        <!-- Custom Dropdown for Add Language Side Panel -->
        <div class="form-group">
          <div class="custom-dropdown" [class.open]="dropdownOpen">
            <div class="dropdown-control" (click)="toggleDropdown()">
              <span class="dropdown-selected-value" *ngIf="selectedLanguage; else placeholder">
                {{ selectedLanguage.name }} ({{ selectedLanguage.native_name }})
              </span>
              <ng-template #placeholder>
                <span class="dropdown-placeholder">Select</span>
              </ng-template>
              <span class="dropdown-arrow" [class.open]="dropdownOpen">
                <!-- <svg width="16" height="16" viewBox="0 0 16 16">
                  <path d="M4 6l4 4 4-4" stroke="#3b82f6" stroke-width="2" fill="none" stroke-linecap="round" />
                </svg> -->
                <img src="./assets/images/new-arrow.svg">
              </span>
            </div>
            <div class="dropdown-list" *ngIf="dropdownOpen">
              <div class="dropdown-search-box">
                <input type="text" class="dropdown-search-input" placeholder="Search language..." [(ngModel)]="dropdownSearchText">
              </div>
              <div class="dropdown-option" *ngFor="let lang of filteredAvailableLanguages()"
                [class.selected]="selectedLanguage?.key === lang.key" (click)="selectDropdownLanguage(lang)">
                {{ lang.name }} ({{ lang.native_name }})
              </div>
              <div class="dropdown-empty" *ngIf="filteredAvailableLanguages().length === 0"> 
                <div *ngIf="dropdownSearchText && dropdownSearchText.trim() !== ''; else allLanguagesAdded">
                  No languages found matching "{{ dropdownSearchText }}"
                </div>
                <ng-template #allLanguagesAdded>
                  All available languages have been added
                </ng-template>
              </div>
            </div>
          </div>
        </div>

        <!-- <div class="selected-language-info" *ngIf="selectedLanguage">
          <div class="info-card">
            <div class="info-item">
              <span class="info-label">Language Name:</span>
              <span class="info-value">{{ selectedLanguage.name }}</span>
            </div>
            <div class="info-item">
              <span class="info-label">Native Name:</span>
              <span class="info-value">{{ selectedLanguage.native_name }}</span>
            </div>
            <div class="info-item">
              <span class="info-label">Language Code:</span>
              <span class="info-value">{{ selectedLanguage.key }}</span>
            </div>
          </div>
        </div> -->
      </div>
    </div>

    <div class="side-panel-footer">
      <button class="btn-cancel" (click)="closeAddLanguageModal()">Cancel</button>
      <button class="btn-save" [disabled]="!selectedLanguage" (click)="addNewLanguage(selectedLanguage)"> Add </button>
    </div>
  </div>
</div>

<!-- Language Edit Modal -->
<div class="language-edit-modal" *ngIf="showEditModal">
  <div class="modal-overlay" (click)="closeEditModal()"></div>
  <div class="modal-container">
    <div class="modal-header">
      <div class="header-label">Edit Language</div>
      <button class="close-button" (click)="closeEditModal()">
        <!-- <i class="fa fa-times lw2-modal-close"></i> -->
        <img src="./assets/images/close.svg">
      </button>
    </div>

    <div class="modal-tabs">
      <button class="modal-tab" [class.active]="activeTab === 'basic'" (click)="setActiveTab('basic')">Basic</button>
      <button class="modal-tab" [class.active]="activeTab === 'advanced'"
        (click)="setActiveTab('advanced')">Advanced</button>
    </div>

    <div class="modal-content">
      <div class="page-edit-form" *ngIf="activeTab === 'basic'">
        <form class="smart-form" style="height: 100%;">
          <div class="row"
            style="font-weight: 800;background-color: #fafafa;padding: 12px;margin: 0px; border-bottom: 1px solid #eaeaea;">
            <div class="col col-6" style="text-transform: capitalize;">
              {{defaultLanguage}}
            </div>
            <div class="col col-6">
              {{editingLanguage.language || 'Select Language'}}
            </div>
          </div>
          <div class="" style="max-height: calc(100% - 50px);overflow: auto;" *ngIf="showLabelFields">
            <div class="row" *ngFor="let key of getLabels(selectedId)" style="margin:0px;padding: 6px">
              <div class="col col-6 ql-editor white-space-normal">
                <label class="label">
                  <p [innerHTML]="trustHTML(getLabelById(defaultLanguage,key)) || 'Please
                          Type Label'"></p>
                </label>
              </div>
              <div class="col col-6">
                <label class="textarea row">
                  <textarea *ngIf="!isLabelRich(key)" [name]="key" [disabled]="!isUserHasWriteAccess" placeholder="Enter label in {{selectedId}}"
                    [(ngModel)]='labelsForEditing[key]'></textarea>
                  <quill-editor *ngIf="isLabelRich(key)" [disabled]="!isUserHasWriteAccess" [(ngModel)]="labelsForEditing[key]"
                    placeholder="'Enter label in {{selectedId}}'">
                  </quill-editor>
                </label>
              </div>
            </div>
          </div>
        </form>
      </div>

      <div class="page-edit-form" *ngIf="activeTab === 'advanced'">
        <div class="translations-container">
          <!-- Header -->
          <div class="translations-header" [class.hidden]="!(isTagValuesAvailables)">
            <!-- <div class="header-label">Dynamic Label</div> -->
            <div class="header-translation">Translation of Dynamic Label</div>
          </div>

          <!-- Content -->
          <div class="translations-content">
            <div class="translation-item" *ngFor="let value of getTagValues(selectedId)">
              <!-- Tag Value Header -->
              <div class="tag-value-header">
                <div class="tag-label">{{'{'+value+'}'}}</div>
              </div>

              <!-- Conditions List -->
              <div class="conditions-list">
                <div class="condition-item"
                  *ngFor="let label_condition of laguage_label_conditions[value]; let cLabelIndex = index">
                  <!-- View Mode -->
                  <div class="condition-view" *ngIf="isValid(label_condition)">
                    <div class="condition-content">
                      <div class="translation-input">
                        <input type="text" [disabled]="!isUserHasWriteAccess" placeholder="Enter translated text here"
                          [(ngModel)]="label_condition.label" />
                      </div>
                      <div class="condition-details">
                        <div class="condition-text">
                          <span>{{label_condition.condition}}</span>
                        </div>
                        <div class="condition-actions">
                          <button class="action-icon edit" *ngIf="isUserHasWriteAccess" (click)="editDynamicLabelCondition(label_condition, value)"
                            title="Edit condition">
                            <img src="./assets/images/editIcon.svg">
                          </button>
                          <button class="action-icon delete"
                            *ngIf="isUserHasWriteAccess"
                            (click)="removeDynamicLabelCondition(value, label_condition, cLabelIndex)"
                            title="Delete condition">
                            <svg class="icon-set">
                              <use [attr.xlink:href]="'./assets/images/icons.svg#trash-can-outline'"></use>
                            </svg>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- Edit Mode -->
                  <div class="condition-edit" *ngIf='displayConditionMap[value].isDisplayCondtionActive'
                    id="{{'studioConditionVisibleIfEditIdContainer_'+cLabelIndex}}"
                    [class.hidden]='!label_condition.isOpen'>
                    <form name="conditionFrm" class="edit-form">
                      <div class="edit-inputs">
                        <input type="text" *ngIf="label_condition.isNew" placeholder="Enter translated text here"
                          [(ngModel)]="label_condition.label" />
                        <div class="condition-input">
                          <input type="text" disable-safe-input placeholder="Enter server visible condition here"
                            [(ngModel)]="label_condition.condition" />
                        </div>
                      </div>
                      <div class="edit-actions">
                        <button type="button" class="btn btn-success"
                          *ngIf="isUserHasWriteAccess"
                          [disabled]="!label_condition.condition || !label_condition.label"
                          (click)="addCondition(value, cLabelIndex)">
                          <i class="fa fa-check"></i> Save
                        </button>
                        <button type="button" class="btn btn-danger" (click)="closeCondition(value, cLabelIndex)">
                          <i class="fa fa-times"></i> Cancel
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>

              <!-- Add New Condition Button -->
              <button type="button" [disabled]="displayConditionMap[value].isDisplayCondtionActive || !isUserHasWriteAccess"
                class="add-condition-btn" (click)="toggleDynamicLabelCondition(value)">
                <i class="fa fa-plus"></i> Add Label & Condition
              </button>
            </div>

            <!-- Empty State -->
            <div class="empty-state" [class.hidden]="isTagValuesAvailables">
              <i class="fa fa-language"></i>
              <p>No tag values configured on the Basic subtab.</p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="modal-footer">
      <button class="btn-cancel" (click)="closeEditModal()">Cancel</button>
      <button class="btn-save" [disabled]="!isUserHasWriteAccess" (click)="addLanguage()">Save Changes</button>
    </div>
  </div>
</div>